import { Directive, HostBinding, Input } from '@angular/core';
import { ThasEventType } from '@thiememeulenhoff/analytics-service-client';
import { AttributeDirective } from './attribute.directive';

@Directive({
  selector: '[thasAction]',
})
export class ActionDirective extends AttributeDirective {
  protected readonly type = ThasEventType.Action;

  @Input('thasAction')
  @HostBinding('attr.data-thas-action')
  public value?: string;
}
